"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.UploadInput = exports.UploadIcon = exports.Text = exports.InnerWrapper = exports.Filename = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireWildcard(require("../Icon"));
var _sizes = _interopRequireDefault(require("../Button/sizes"));
var _variants = _interopRequireDefault(require("../Button/variants"));
var _style = require("../Button/style");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "fluffy--Wrapper",
  componentId: "fluffy--1cvqkp"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n"], ["\n    display: flex;\n    position: relative;\n"])));
exports.Wrapper = Wrapper;
var InnerWrapper = _styledComponents.default.label.withConfig({
  displayName: "fluffy--InnerWrapper",
  componentId: "fluffy--146h9fb"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n"], ["\n    ", ";\n    ", ";\n    ", ";\n"])), _style.baseButtonStyle, function (_a) {
  var $size = _a.$size;
  return _sizes.default[$size || 'normal'];
}, function (_a) {
  var $variant = _a.$variant,
    $variantType = _a.$variantType;
  return _variants.default[$variant || 'primary']($variantType);
});
exports.InnerWrapper = InnerWrapper;
var UploadInput = _styledComponents.default.input.withConfig({
  displayName: "fluffy--UploadInput",
  componentId: "fluffy--tx6z3k"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
exports.UploadInput = UploadInput;
var UploadIcon = (0, _styledComponents.default)(_Icon.default).attrs(function () {
  return {
    icon: _Icon.Icons.ArrowUpOnSquare
  };
}).withConfig({
  displayName: "fluffy--UploadIcon",
  componentId: "fluffy--1t47dcz"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: auto;\n    margin-bottom: auto;\n    fill: currentColor;\n    margin-right: 10px;\n"], ["\n    margin-top: auto;\n    margin-bottom: auto;\n    fill: currentColor;\n    margin-right: 10px;\n"])));
exports.UploadIcon = UploadIcon;
var Text = _styledComponents.default.span.withConfig({
  displayName: "fluffy--Text",
  componentId: "fluffy--1ltpxqh"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n"], ["\n\n"])));
exports.Text = Text;
var Filename = _styledComponents.default.p.withConfig({
  displayName: "fluffy--Filename",
  componentId: "fluffy--rqlnm6"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: #494949;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    margin: auto 0 auto 15px;\n"], ["\n    color: #494949;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    margin: auto 0 auto 15px;\n"])));
exports.Filename = Filename;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;